import { type FC } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { renderGeneAttributesWidgets } from "@/app-utils/attributes-widgets.tsx";
import { useURLViewID } from "@/app-utils/hooks/useUrl.ts";
import { type InputTableQuerySpec } from "@/graphql.ts";
import { type IGeneState } from "@/redux/modules/gene.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { DATATABLE_ID_TYPE, ENTITY_TYPE } from "@/settings/settings.js";

import { AttributesListWidget } from "../core/navigation-panel/AttributeWidget.js";
import GenericVariantsView from "./GenericVariantsView.js";

const GeneVariantsView: FC = () => {
  const { geneId } = useParams<"geneId">();
  const viewId = useURLViewID();
  const { gene, isLoading } = useSelector<IAppState, IGeneState>((state) => state.gene);
  const refGenomeId = useSelector<IAppState>((state) => state.auth.session?.params?.referenceGenome);

  const tableSpec: InputTableQuerySpec = !isLoading &&
    refGenomeId && {
      id: geneId,
      idType: DATATABLE_ID_TYPE.ENTITY,
      queryType: ENTITY_TYPE.GENE,
      resultType: ENTITY_TYPE.GENE_MUTATION,
      restrictions: { refGenomeId },
    };

  return (
    <GenericVariantsView
      title={gene?.name ?? ""}
      subtitle={gene?.description || "List of Variants"}
      headerAttributes={[
        <AttributesListWidget attributes={renderGeneAttributesWidgets(gene)} key={"gene-variants-view-widget-1"} />,
      ]}
      tableSpec={tableSpec}
      viewId={viewId ?? undefined}
      getSummaryEntityName={() => gene?.name ?? ""}
    />
  );
};

export default GeneVariantsView;
